import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon';
import { LONG_DASH } from '@dealstack/frontend/shared/other/react/specialSigns.tsx';
import { makeComplexDataTestId, TEST_ELEMENT_IDS } from '@dealstack/shared/tests/testElementIds.ts';
import { Badge, Flex, Text } from '@mantine/core';

interface Props {
	bankAccountId: string;
	riskCount: number;
}

export const RiskCell = ({ bankAccountId, riskCount }: Props) => {
	if (riskCount <= 0) {
		return <Text size="sm">{LONG_DASH}</Text>;
	}

	return (
		<Badge
			variant="outline"
			size="sm"
			color="red.8"
			data-testid={makeComplexDataTestId(
				TEST_ELEMENT_IDS.MIP_MANAGE_BANK_ACCOUNT_RISK_BADGE,
				bankAccountId
			)}
		>
			<Flex align="center" gap="0.25rem">
				<Icon variant="warning" size="md" />
				<Text size="sm" fw={400}>
					{riskCount}
				</Text>
			</Flex>
		</Badge>
	);
};
